import { setErrorMessage } from '../actions/spamErrorMessageMutatorActions';
import { addToSpamList } from '../actions/spamListMutatorActions';
import { clearNewSpamItem } from '../actions/spamNewItemMutatorActions';
import getSpamScenarioStore from '../selectors/getSpamScenarioStore';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { assertNever, KeyCodes } from '@uifabric/utilities';
import { observer } from 'mobx-react';
import { ITextField, TextField } from 'office-ui-fabric-react/lib/components/TextField';
import * as React from 'react';
import validateSenderOrDomain, {
    EditSendersAndDomainsMode,
    validationErrorMessage,
    ValidationResult,
} from '../utils/validateSenderOrDomain';

const styles = require('./SpamOptionFull.scss');

export interface SpamOptionTextFieldProps {
    index: number;
    isEditMode: boolean;
    placeHolder: string;
    rowTextValue: string;
    scenarioId: SpamScenarioId;
}

@observer
export default class SpamOptionTextField extends React.Component<SpamOptionTextFieldProps, {}> {
    private textField: ITextField;

    focus() {
        this.textField.focus();
    }

    render() {
        const { placeHolder, rowTextValue, scenarioId } = this.props;
        const optionState = getSpamScenarioStore(scenarioId);
        return (
            <TextField
                className={styles.textField}
                autoFocus={true}
                componentRef={this.onTextFieldRef}
                onBlur={this.onBlur}
                onKeyDown={this.onKeyDown}
                placeholder={placeHolder}
                defaultValue={rowTextValue}
                errorMessage={optionState.errorMessage}
            />
        );
    }

    private onTextFieldRef = (ref: ITextField) => {
        this.textField = ref;
    };

    private onKeyDown = (evt: React.KeyboardEvent<unknown>): void => {
        let errorMessage: string;
        const { index, scenarioId } = this.props;
        const optionState = getSpamScenarioStore(scenarioId);
        switch (evt.which) {
            case KeyCodes.enter:
                if (this.textField.value && this.textField.value.length > 0) {
                    errorMessage = this.getErrorMessage();
                    setErrorMessage(scenarioId, errorMessage);
                    if (!optionState.errorMessage) {
                        addToSpamList(scenarioId, this.textField.value, index);
                        clearNewSpamItem(scenarioId);
                    }
                }
                break;
            case KeyCodes.escape:
                clearNewSpamItem(this.props.scenarioId);
                break;
        }
    };

    private onBlur = (evt: React.FocusEvent<EventTarget>): void => {
        const { isEditMode, scenarioId, index } = this.props;
        if (!isEditMode) {
            addToSpamList(scenarioId, this.textField.value, index);
        }
        clearNewSpamItem(scenarioId);
        setErrorMessage(scenarioId, null /* error string */);
    };

    private getEditSendersAndDomainsMode = (): EditSendersAndDomainsMode => {
        switch (this.props.scenarioId) {
            case SpamScenarioId.BlockedSendersAndDomains:
                return EditSendersAndDomainsMode.EmailAddressAndDomain;
            case SpamScenarioId.SafeSendersAndDomains:
                return EditSendersAndDomainsMode.EmailAddressAndDomain;
            case SpamScenarioId.SafeMailingLists:
                return EditSendersAndDomainsMode.EmailAddressOnly;
            case SpamScenarioId.AllowedDynamicEmailSenders:
                return EditSendersAndDomainsMode.EmailAddressOnlyAllowSelf;
            default:
                return assertNever(this.props.scenarioId);
        }
    };

    private getErrorMessage = (): string => {
        const validationMode = this.getEditSendersAndDomainsMode();
        const result = validateSenderOrDomain(validationMode, this.textField.value);
        if (result === ValidationResult.OK) {
            return undefined;
        } else {
            return validationErrorMessage(result);
        }
    };
}
